import axios from 'axios'
import { boundary, JSON_URL } from '../../api'

const apiUrl = boundary

export function loadBoundary(pageLimit, page, type, search) {
  return axios.get(`${apiUrl}/boundary/filter?limit=${pageLimit}&offset=${page}&dictionary_boundary_type__dictionary_item_name_en=${type}&search=${search}`)
}

export function loadBoundaryByParent(parentId) {
  return axios.get(`${apiUrl}/boundary/getByParent/${parentId}/`)
}

export function loadAllBoundary() {
  return axios.get(`${apiUrl}/boundary/filter`)
}

export function loadBoundaryByIsland(pageLimit, page, type, islandId) {
  return axios.get(`${apiUrl}/boundary/filter?limit=${pageLimit}&offset=${page}&dictionary_boundary_type__dictionary_item_name_en=${type}&island_id=${islandId}`)
}

export function loadOneBoundaryMap(id) {
  return axios.get(`${apiUrl}/boundary/map/${id}`)
}

export function loadBoundaryGeoJson(typeId, parentId) {
  let params = 'limit=100000';
  if (typeId) params += `&dictionary_boundary_type_id=${typeId}`;
  if (parentId) params += `&boundary_parent=${parentId}`;
  return axios.get(`${JSON_URL}register.register_boundary_polygon/items.json?${params}`)
}

export function loadBoundaryLeader(pageLimit, page, search) {
  return axios.get(`${apiUrl}/boundary/leader/filter?limit=${pageLimit}&offset=${page}&search=${search}`)
}

export function getBoundaries() {
  return axios.get(`${apiUrl}/boundary/getBoundary`)
}

export function addBoundaryLeader(data) {
  return axios.post(`${apiUrl}/boundary/leader`, data)
}

export function getBoundaryLeader(id) {
  return axios.get(`${apiUrl}/boundary/leader/${id}`)
}

export function updateBoundaryLeader(id, data) {
  return axios.put(`${apiUrl}/boundary/leader/${id}`, data)
}

export function addBoundary(data) {
  return axios.post(`${apiUrl}/boundary/boundary`, data)
}

export function loadBoundaryById(id) {
  return axios.get(`${apiUrl}/boundary/update/${id}`)
}

export function updateBoundary(id, data) {
  return axios.put(`${apiUrl}/boundary/update/${id}`, data)
}

// Island CRUD functions
export function loadIslands(pageLimit, page, search) {
  return axios.get(`${apiUrl}/island/filter?limit=${pageLimit}&offset=${page}&search=${search}`)
}

export function loadAllIslands() {
  return axios.get(`${apiUrl}/island/all`)
}

export function loadIslandById(id) {
  return axios.get(`${apiUrl}/island/update/${id}`)
}

export function addIsland(data) {
  return axios.post(`${apiUrl}/island`, data)
}

export function updateIsland(id, data) {
  return axios.put(`${apiUrl}/island/update/${id}`, data)
}

export function loadIslandMap(id) {
  return axios.get(`${apiUrl}/island/map/${id}`)
}

// Current user's map scope: { is_national, boundary_id, level, centroid, polygon }
export function loadScopeMe() {
  return axios.get(`${apiUrl}/scope/me`)
}

// Upload boundaries from CSV
export function uploadBoundary(formData) {
  return axios.post(`${apiUrl}/boundary/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}